import React from 'react'
import ArrowImg from '../../assets/images/arrow.png'


function ArrowImage() {
  return (
    <div>
      <img src={ArrowImg} alt=""></img>
    </div>
  )
}

export default ArrowImage
